import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class GeneralMembers extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            fromMember: '',
            toMember: '',
            includeMemberProgramUsers: true,
            includeMemberProgramNonUsers: false,
            //listType: '',
            selectedListTypes: [],
        });
    }

    fields = [];
    render() {
        return <div className="general-members">
            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <label className={'header'}>Filtréring (valgfrit)</label>}
            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className={'upper-container'}>
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromSection"
                            id="fromSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.fromSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toSection"
                            id="toSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.toSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[1] = instance; }}
                        />
                    </div>
                </div> : null}
                <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromClub"
                            id="fromClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.fromClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[2].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[2] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toClub"
                            id="toClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.toClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[3].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[3] = instance; }}
                        />
                    </div>
                </div>
            </div>}
            <label className={'header'}>Listetype</label>
            <div className={'lower-container'}>
                <div className={'list-type-container'}>
                    <div>
                        <table style={{maxWidth: '600px'}}>
                            <tbody>
                                <tr>
                                    <td>
                                        <input id="listtype0" type="checkbox" checked={this.state.selectedListTypes.indexOf(0) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype0">Foreningsvist efter nummer</label>
                                    </td>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>
                                        <input id="listtype1" type="checkbox" checked={this.state.selectedListTypes.indexOf(1) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype1">Foreningsvist efter navn</label>
                                    </td> : null}
                                </tr>
                                <tr>
                                    <td>
                                        <input id="listtype2" type="checkbox" checked={this.state.selectedListTypes.indexOf(2) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype2">Postnummer</label>
                                    </td>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>
                                        <input id="listtype3" type="checkbox" checked={this.state.selectedListTypes.indexOf(3) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype3">Familiemedlemmer</label>
                                    </td> : null}
                                </tr>
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype4" type="checkbox" checked={this.state.selectedListTypes.indexOf(4) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype4">Modtagere af Brevduen</label>
                                    </td>
                                    <td>
                                        <input id="listtype11" type="checkbox" checked={this.state.selectedListTypes.indexOf(11) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype11">Passive medlemmer</label>
                                    </td>
                                </tr> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype5" type="checkbox" checked={this.state.selectedListTypes.indexOf(5) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype5">SMS-abonnementer</label>
                                    </td>
                                    <td>
                                        <input id="listtype6" type="checkbox" checked={this.state.selectedListTypes.indexOf(6) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype6">SIM-kort-abonnementer</label>
                                    </td>
                                </tr> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype7" type="checkbox" checked={this.state.selectedListTypes.indexOf(7) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype7">TAURIS-abonnementer</label>
                                    </td>
                                    <td>
                                        <input id="listtype8" type="checkbox" checked={this.state.selectedListTypes.indexOf(8) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype8">UNIKON-abonnemente</label>
                                    </td>
                                </tr> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype9" type="checkbox" checked={this.state.selectedListTypes.indexOf(9) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype9">Kontingent pr. sektion</label>
                                    </td>
                                    <td>
                                        <input id="listtype10" type="checkbox" checked={this.state.selectedListTypes.indexOf(10) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype10">Kontingent pr. forening</label>
                                    </td>
                                </tr> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype12" type="checkbox" checked={this.state.selectedListTypes.indexOf(12) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype12">Dispensationer</label>
                                    </td>
                                    <td>
                                        <input id="listtype13" type="checkbox" checked={this.state.selectedListTypes.indexOf(13) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype13">Brugere af medlemsprogrammet</label>
                                    </td>
                                </tr> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <tr>
                                    <td>
                                        <input id="listtype14" type="checkbox" checked={this.state.selectedListTypes.indexOf(14) >= 0} onClick={this.onSelectListType}/> <label htmlFor="listtype14">CHR</label>
                                    </td>
                                    <td>
                                        &nbsp;
                                    </td>
                                </tr> : null}
                            </tbody>
                        </table>
                        {/*<UserFieldElement
                            dataType={UserFieldDataType.enum}
                            placeholder={'Vælg liste'}
                            className="field300"
                            containerClassName="display-inline-block"
                            name="sectionPicker"
                            id="sectionPicker"
                            value={this.state.listType}
                            multiple
                            options={[
                                {key: '0', value: 'Foreningsvist efter nummer'},
                                {key: '1', value: 'Foreningsvist efter navn'},
                                {key: '2', value: 'Postnummer'},
                                {key: '3', value: 'Familiemedlemmer'},
                                {key: '4', value: 'Modtagere Brevduen'},
                                {key: '5', value: 'SMS-abonnementer'},
                                {key: '6', value: 'SIM-kort-abonnementer'},
                                {key: '7', value: 'TAURIS-abonnementer'},
                                {key: '8', value: 'UNIKON-abonnementer'},
                                {key: '9', value: 'Kontingent pr. sektion'},
                                {key: '10', value: 'Kontingent pr. forening'},
                                {key: '11', value: 'Passive medlemmer'},
                                {key: '12', value: 'Dispensationer'},
                            ]}
                            autoCheckErrors={true}
                            required={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            ref={instance => { this.fields[6] = instance; }}
                            onChange={e => {
                                this.setState({listType: e.target.value})
                            }}
                        />*/}
                    </div>
                </div>
                {/*Only relevant if the 'kontigent' calculation can be filtered on member number */}
                {//this.state.listType === '1' ||
                 //this.state.listType === '9' ||
                 //this.state.listType === '10' ?
                 this.state.selectedListTypes.indexOf(1) >= 0 ||
                 this.state.selectedListTypes.indexOf(9) >= 0 ||
                 this.state.selectedListTypes.indexOf(10) >= 0 ?
                     <div className={'subscription-container'}>
                         <label>Filtrér beregning af kontingent (valgfrit)</label>
                         <div className={'attribute-row'}>
                             <div className={'attribute-pair'}>
                                 <label>Fra medlemsnummer</label>
                                 <UserFieldElement
                                     dataType={UserFieldDataType.regex}
                                     placeholder=""
                                     className="field-1 small-field"
                                     containerClassName="display-inline-block"
                                     name="fromMember"
                                     id="fromMember"
                                     maxLength="6"
                                     options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]}
                                     value={this.state.fromMember}
                                     autoCheckErrors={true}
                                     hideErrWhenFocused={true}
                                     hideErrUntilFocused={true}
                                     onChange={this.onDigitInputFieldChange}
                                     onBlur={() => {
                                         this.fields[4].setState({focused: false, visited: true});
                                         if (/^[0-9]{1,5}$/.test(this.state.fromMember)) this.setState({fromMember: this.state.fromMember.padStart(6, '0')});
                                     }}
                                     ref={instance => { this.fields[4] = instance; }}
                                 />
                             </div>
                             <div className={'attribute-pair'}>
                                 <label>Til medlemsnummer</label>
                                 <UserFieldElement
                                     dataType={UserFieldDataType.regex}
                                     placeholder=""
                                     className="field-1 small-field"
                                     containerClassName="display-inline-block"
                                     name="toMember"
                                     id="toMember"
                                     maxLength="6"
                                     options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{6}"}]}
                                     value={this.state.toMember}
                                     autoCheckErrors={true}
                                     hideErrWhenFocused={true}
                                     hideErrUntilFocused={true}
                                     onChange={this.onDigitInputFieldChange}
                                     onBlur={() => {
                                         this.fields[5].setState({focused: false, visited: true});
                                         if (/^[0-9]{1,5}$/.test(this.state.toMember)) this.setState({toMember: this.state.toMember.padStart(6, '0')});
                                     }}
                                     ref={instance => { this.fields[5] = instance; }}
                                 />
                             </div>
                         </div>
                     </div>
                    : null }
                {this.state.selectedListTypes.indexOf(13) >= 0 ?
                    <div className={'subscription-container'}>
                        <div className={'attribute-row'}>
                            <div className={'attribute-pair'}>
                                <span>
                                    <input id="memberProgramUsers" type="checkbox" checked={this.state.includeMemberProgramUsers} onClick={() => {this.setState({includeMemberProgramUsers: !this.state.includeMemberProgramUsers})}}/> <label htmlFor="memberProgramUsers">Inkluder brugere</label>
                                </span>
                            </div>
                            <div className={'attribute-pair'}>
                                <span>
                                    <input id="memberProgramNonUsers" type="checkbox" checked={this.state.includeMemberProgramNonUsers} onClick={() => {this.setState({includeMemberProgramNonUsers: !this.state.includeMemberProgramNonUsers})}}/> <label htmlFor="memberProgramNonUsers">Inkluder ikke-brugere</label>
                                </span>
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        </div>
    }

    onSelectListType = (e) => {
        const listId = Number(e.target.id.substr(8));
        const ix = this.state.selectedListTypes.indexOf(listId);
        if (ix < 0) this.state.selectedListTypes.push(listId);
        else this.state.selectedListTypes.splice(ix, 1);
        this.forceUpdate();
    };

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromSection !== '' && this.state.toSection !== '' && this.state.fromSection > this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
        if (this.state.fromClub    !== '' && this.state.toClub    !== '' && this.state.fromClub    > this.state.toClub)    errors.push('Fra forening kan ikke være større end Til forening.');
        if (this.state.fromMember  !== '' && this.state.toMember  !== '' && this.state.fromMember  > this.state.toMember)  errors.push('Fra medlem kan ikke være større end Til medlem.');

        if (this.state.selectedListTypes.length === 0) errors.push('Vælg mindst én listetype.');

        let options = {
            fromSection:this.state.fromSection === '' ? null : this.state.fromSection,
            toSection:  this.state.toSection   === '' ? null : this.state.toSection  ,
            fromClub:   this.state.fromClub    === '' ? null : this.state.fromClub   ,
            toClub:     this.state.toClub      === '' ? null : this.state.toClub     ,
            listTypes:  this.state.selectedListTypes,
            //listType:   Number(this.state.listType),
        }

        if (this.state.selectedListTypes.indexOf(1) >= 0 || this.state.selectedListTypes.indexOf(9) >= 0 || this.state.selectedListTypes.indexOf(10) >= 0) {
        //if (this.state.listType === '1' || this.state.listType === '9' || this.state.listType === '10') {
            options.fromMember = this.state.fromMember  === '' ? null : this.state.fromMember;
            options.toMember =   this.state.toMember    === '' ? null : this.state.toMember;
        }

        if (this.state.selectedListTypes.indexOf(13) >= 0) {
            options.includeMemberProgramUsers = this.state.includeMemberProgramUsers;
            options.includeMemberProgramNonUsers = this.state.includeMemberProgramNonUsers;
        }


        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralMembers);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralMembers.js